import { render, staticRenderFns } from "./activityAuditReasonsForChange.vue?vue&type=template&id=697a87bb&scoped=true&"
import script from "./activityAuditReasonsForChange.vue?vue&type=script&lang=js&"
export * from "./activityAuditReasonsForChange.vue?vue&type=script&lang=js&"
import style0 from "./activityAuditReasonsForChange.vue?vue&type=style&index=0&id=697a87bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697a87bb",
  null
  
)

export default component.exports